export const GET_OFFERINGS = 'offering/getOfferings';
export const GET_OFFERING_YEARS = 'offering/getOfferingYears';
export const CREATE_OFFERING = 'offering/createOffering';
export const DELETE_OFFERING = 'offering/deleteOffering';
